export enum AUTOLOG_STATUS {
	SUCCESS = 'success',
	FAIL = 'fail',
}

const AuthApps = ['Deezer', 'Zen', 'Shaker', 'Games'] as const;
export type AppName = (typeof AuthApps)[number];
